import { render, staticRenderFns } from "./InvoiceAddressData.vue?vue&type=template&id=08d4514a&scoped=true"
import script from "./InvoiceAddressData.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceAddressData.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoiceAddressData.vue?vue&type=style&index=0&id=08d4514a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4514a",
  null
  
)

export default component.exports